export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
}
